export default __webpack_public_path__ + "static/media/ic_home_active.f4855eb7.svg";